import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";
import { TimerState } from "./timer.state";

export const TimerSelectors = (entityStateId: string) => {
  const selectTimerState = createFeatureSelector<TimerState>(entityStateId);
  (selectTimerState as any).__isFeatureSelector = true;
  const selectNonNullTimerState = createSelector(
    selectTimerState as MemoizedSelector<object, any | undefined>,
    (state) => state ?? null
  );

  const selectTimerText = createSelector(
    selectNonNullTimerState,
    (state: TimerState) => state?.name,
  );
  return {
    selectTimerState,
    selectTimerText
  }
}

